// extracted by mini-css-extract-plugin
export default {"heart":"BeatingHeart_heart__L5B-q","beat":"BeatingHeart_beat__23Q5Q"};